import moment from "moment";
import React from "react";
import { ticketStatus } from "utils/common-options";
import ZithasLogo from "../../../assets/images/main-zithas.png";
import configure from "configure";
import bug from "../../../assets/images/flags/bug-icon.png";
import Suggestion from "../../../assets/images/flags/sugg-icon.png";
import {
  addMultiples,
  convertMinutesToTimeString,
  getInitials,
} from "utils/common-helpers";
import { Link } from "react-router-dom";

export const earthTicketsColumns = (onReply, userClosed, onClosed) => [
  {
    Header: "ID",
    accessor: "id",
    title: "ID",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center",
  },
  // {
  //     Header: "Added By",
  //     title: "type_name",
  //     accessor: "added_by",
  //     isInfoIcon: false,
  //     isShortIcon: true,
  //     className: "text-center",
  //     Cell: cellProps => {
  //         const icon = cellProps.row?.original?.type == 0 ? bug : Suggestion
  //         return (
  //             <div>
  //                 <img src={`${cellProps.row?.original?.user_pic != null ? `${configure.imgUrl}${cellProps.row?.original?.user_pic}` : ZithasLogo}`} alt="" className="img-fluid assignee-img" title={cellProps.row?.original?.user_name}></img>
  //                 {icon != null ? (
  //                     <img src={icon} alt="" className="img-fluid assignee-img ms-2" ></img>
  //                 ) : null}
  //             </div>
  //         )
  //     },
  // },
  {
    Header: "Added By",
    title: "type_name",
    accessor: "added_by",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center",
    Cell: (cellProps) => {
      const icon = cellProps.row?.original?.type == 0 ? bug : Suggestion;
      return (
        <div className="d-flex align-items-center">
          {cellProps.row?.original?.user_pic ? (
            <img
              src={`${cellProps.row?.original?.user_pic != null
                ? `${configure.imgUrl}${cellProps.row?.original?.user_pic}`
                : ZithasLogo
                }`}
              alt=""
              className="img-fluid assignee-img"
              title={cellProps.row?.original?.user_name}
            ></img>
          ) : (
            <span
              className="defualt-img "
              title={cellProps.row?.original?.user_name}
            >
              {getInitials(cellProps.row?.original?.user_name || "Z")}
            </span>
          )}
          {icon != null ? (
            <img
              src={icon}
              alt=""
              className="img-fluid assignee-img ms-2"
            ></img>
          ) : null}
        </div>
      );
    },
  },
  {
    Header: "Title",
    title: "Task Name",
    accessor: "subject",
    isInfoIcon: false,
    isShortIcon: true,
    className: "stask_name_box",
  },
  {
    Header: "Status",
    title: "Status",
    accessor: "status_col",
    isInfoIcon: false,
    isShortIcon: true,
    className: "sstatus_box ",
    Cell: (cellProps) => {
      return (
        <div className="custom-select-wrapper">
          {
            ticketStatus?.find(
              (obj) => obj?.value == cellProps.row?.original?.status
            )?.label
          }
        </div>
      );
    },
  },
  {
    Header: "Priority",
    title: "Priority",
    accessor: "priority",
    isInfoIcon: false,
    isShortIcon: true,
    className: "prioritys_col_box text-capitalize text-center",
    Cell: (cellProps) => {
      const cellValue = cellProps.value;
      let style = {};

      if (cellValue?.toLowerCase() == "high") {
        style = { color: "red" };
      } else if (cellValue?.toLowerCase() == "medium") {
        style = { color: "blue" };
      } else if (cellValue?.toLowerCase() == "low") {
        style = { color: "green" };
      }

      return (
        <div style={style} className="text-capitalize">
          {cellValue}
        </div>
      );
    },
  },
  {
    Header: "Created At",
    title: "created at",
    accessor: "created_at",
    isInfoIcon: false,
    isShortIcon: true,
    className: "screated_at_col-box",
    Cell: (cellProps) => {
      return (
        <div>
          {moment(cellProps?.row?.original?.created_at).format("DD-MM-YYYY")}
        </div>
      );
    },
  },
  {
    Header: "Last Reply",
    title: "Last Reply",
    accessor: "last_reply",
    isInfoIcon: false,
    isShortIcon: true,
    className: "slast_reply_col-box ",
  },
  {
    Header: "Action",
    accessor: "action",
    className: "msupport_action text-center",
    Cell: (cellProps) => {
      return (
        <div className="d-flex justify-content-center">
          <a
            onClick={() => onReply(cellProps?.row?.original)}
            className="btn btn-sm btn-outline-secondary me-1"
            title="Reply Ticket"
          >
            <i className="bi bi-reply-fill"></i>
          </a>
          {userClosed ? (
            <a
              onClick={() => onClosed(cellProps?.row?.original)}
              className="btn btn-sm btn-outline-success me-1"
              title="Closed Ticket"
            >
              <i className="bi bi-check2-circle"></i>
            </a>
          ) : null}
        </div>
      );
    },
  },
];

export const projectCoinsColumns = (isShow, handleSendTesting) => [
  {
    Header: "Project Name",
    accessor: "project_name",
    isInfoIcon: false,
    isShortIcon: true,
    className: " col-md-6",
  },
  {
    Header: "Total Hrs",
    accessor: "total_hrs",
    isInfoIcon: false,
    isShortIcon: true,
    className: " col-md-1 text-center ",
    Cell: (cellProps) => {
      const obj = cellProps?.row?.original;
      return (
        <div>
          {addMultiples(obj?.used_dev_hrs, obj?.used_kam_hrs, obj?.used_qa_hrs)}
          /{obj?.total_hrs}
        </div>
      );
    },
  },
  {
    Header: "Dev Hrs",
    accessor: "dev_hrs",
    isInfoIcon: false,
    isShortIcon: true,
    className: " col-md-1 text-center ",
    Cell: (cellProps) => {
      const obj = cellProps?.row?.original;
      return (
        <div>
          {obj?.used_dev_hrs}/{obj?.dev_hrs}
        </div>
      );
    },
  },
  {
    Header: "KAM Hrs",
    accessor: "kam_hrs",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center  col-md-1",
    Cell: (cellProps) => {
      const obj = cellProps?.row?.original;
      return (
        <div>
          {obj?.used_kam_hrs}/{obj?.kam_hrs}{" "}
        </div>
      );
    },
  },
  {
    Header: "QA Hrs",
    accessor: "qa_hrs",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center  col-md-1",
    Cell: (cellProps) => {
      const obj = cellProps?.row?.original;
      return (
        <div>
          {obj?.used_qa_hrs}/{obj?.qa_hrs}{" "}
        </div>
      );
    },
  },
  {
    Header: "Tickets",
    accessor: "total_tickets",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center  col-md-1",
  },
  {
    Header: "Tickets Queries",
    accessor: "tickets_queries",
    className: " text-center  col-md-1",
  },
  {
    Header: "Round",
    accessor: "rounds",
    className: "stask_name_box",
    Cell: (cellProps) => {
      const obj = cellProps?.row?.original;
      return <div>{obj?.rounds || "-"} </div>;
    },
  },
  {
    Header: "Start Date",
    accessor: "startdate",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center  col-md-1",
    Cell: (cellProps) => {
      const obj = cellProps?.row?.original;
      return <div>{moment(obj?.startdate).format("DD-MM-YYYY")} </div>;
    },
  },
  {
    Header: "End Date",
    accessor: "enddate",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center  col-md-1",
    Cell: (cellProps) => {
      const obj = cellProps?.row?.original;
      return <div>{moment(obj?.enddate).format("DD-MM-YYYY")} </div>;
    },
  },
  {
    Header: "Tasks",
    accessor: "total_tasks",
    isInfoIcon: false,
    isShortIcon: true,
    className: "stask_name_box",
    Cell: (cellProps) => {
      const obj = cellProps?.row?.original;
      return (
        <div>
          {obj?.dev_complete_tasks}/{obj?.total_tasks}
        </div>
      );
    },
  },
  ...(isShow
    ? [
      {
        Header: "Action",
        accessor: "subject",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center col-md-1",
        Cell: (cellProps) => {
          const obj = cellProps?.row?.original;
          return (
            <a
              className="btn btn-sm btn-outline-success me-1"
              title="Send For Testing"
              onClick={() => handleSendTesting(obj?.id)}
            >
              <i className="fas fa-arrow-right"></i>
            </a>
          );
        },
      },
    ]
    : []),
];
export const allProjectsColumns = () => [
  {
    Header: "ID",
    accessor: "id",
    title: "ID",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center project_id ",
  },
  {
    Header: "Project Name",
    accessor: "project_name",
    isInfoIcon: false,
    isShortIcon: true,
    className: "project_name_box",
    Cell: (cellProps) => {
      return (
        <div className="d-flex gap-2 align-items-center">
          <img
            src={`${configure.imgUrl}${cellProps?.row?.original?.kam_avatar}`}
            alt=""
            className="img-fluid assignee-img ms-2"
            title={cellProps?.row?.original?.kam_name}
          />
          <span>{cellProps?.row?.original?.project_name}</span>
        </div>
      );
    },
  },
  {
    Header: "Customer",
    accessor: "customer",
    isInfoIcon: false,
    isShortIcon: true,
    className: "customer_name_box",
  },
  {
    Header: "Start Date",
    accessor: "start_date",
    isInfoIcon: false,
    isShortIcon: true,
    className: "start_date_box",
    Cell: (cellProps) => {
      return (
        <div className="">
          {moment(cellProps?.row?.original?.startdate).format("DD-MM-YYYY")}
        </div>
      );
    },
  },
  {
    Header: "End Date",
    accessor: "end_date",
    isInfoIcon: false,
    isShortIcon: true,
    className: " due_date_box text-center",
    Cell: (cellProps) => {
      return (
        <div className="">
          {moment(cellProps?.row?.original?.enddate).format("DD-MM-YYYY")}
        </div>
      );
    },
  },
  {
    Header: "Hours",
    accessor: "total_hrs",
    isInfoIcon: false,
    isShortIcon: true,
    className: "msupport_action text-center",
  },
  {
    accessor: "action",
    Header: "Action",
    className: "msupport_action text-center",
    Cell: (cellProps) => {
      return (
        <div className="d-flex justify-content-center">
          <Link
            to={`${configure.appUrl}work/edit-project/${cellProps?.row?.original?.id}`}
            className="btn btn-sm btn-outline-secondary me-1"
            title="Reply Ticket"
          >
            <i className="fas fa-arrow-right"></i>
          </Link>
        </div>
      );
    },
  },
];
export const overAllWorkColumns = () => [
  {
    Header: "ID",
    accessor: "id",
    title: "ID",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-1 text-center",
    Cell: (cellProps) => {
      const data = cellProps?.row?.original;
      const ids =
        data?.type == "activity"
          ? data?.id
          : data?.type == "project_task"
            ? data?.task_id
            : data?.type == "digital-project"
              ? data?.id
              : data?.id;
      return <div>{ids}</div>;
    },
  },
  {
    Header: "Activity Name",
    accessor: "project_name",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-7 ",
    Cell: (cellProps) => {
      const row = cellProps.row.original;
      const rawAvatar =
        row?.avatar || row?.assignee_avatar || row?.staff_avatar;
      const avatar =
        rawAvatar && rawAvatar !== "null"
          ? `${configure.imgUrl}${rawAvatar}`
          : null;
      const name =
        row?.task_title || row?.subject || row?.name || row?.title || "";
      return (
        <div className="d-flex gap-2 align-items-center">
          {avatar && avatar != null ? (
            <img
              src={avatar}
              alt="Avatar"
              className="img-fluid assignee-img ms-2"
              title={row?.staff_name || row?.alias_name || row?.assignee || ""}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = ZithasLogo;
              }}
            />
          ) : (
            <div
              className="defualt-img "
              title={row?.staff_name || row?.alias_name || row?.assignee || ""}
            >
              {getInitials(
                row?.staff_name || row?.alias_name || row?.assignee || ""
              )}
            </div>
          )}

          <span>{name}</span>
        </div>
      );
    },
  },
  {
    Header: "Role",
    accessor: "role_name",
    title: "Role",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-2 text-center",
  },
  {
    Header: "Type",
    accessor: "type",
    title: "Type",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-1 text-center",
    Cell: (cellProps) => {
      const type = cellProps?.row?.original?.type || "N/A";
      return <div className="text-capitalize">{type.replace("_", " ")}</div>;
    },
  },
  {
    Header: "Est.Time",
    accessor: "est_hrs",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-1 text-center",
    Cell: (cellProps) => {
      const { est_hrs, estimation_time, estimate_time, type } =
        cellProps.row.original;
      return (
        <div>
          {est_hrs ||
            estimation_time ||
            estimate_time ||
            `${type == "support_ticket" ? "-" : ""}`}
        </div>
      );
    },
  },
  {
    Header: "Act.Time",
    accessor: "time",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col_md-1 text-center",
    Cell: (cellProps) => {
      const { time } = cellProps.row.original;
      return <div>{time}</div>;
    },
  },
  {
    Header: "Today's Time",
    accessor: "total_actual_time",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center col_md-2",
    Cell: (cellProps) => {
      const {
        act_hrs,
        dev_hrs,
        start_time,
        end_time,
        total_actual_time,
        type,
        time_taken_minutes,
      } = cellProps.row.original;
      let formattedDuration = "00:00";
      if (start_time && end_time) {
        const duration = moment.duration(
          moment(end_time).diff(moment(start_time))
        );
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        formattedDuration = `${String(hours).padStart(2, "0")}:${String(
          minutes
        ).padStart(2, "0")}`;
      }
      // return <div>{act_hrs || dev_hrs || `${type == "support_ticket" ? '-' : ''}` || `${type != "digital-project" || type != 'support_ticket' ? convertMinutesToTimeString(total_actual_time || 0) : ''} `}</div>
      return (
        <div>
          {act_hrs ||
            dev_hrs ||
            `${type != "digital-project"
              ? convertMinutesToTimeString(total_actual_time || 0)
              : ""
            } `}
        </div>
      );
    },
  },
];

export const MilestoneDelayedProjectsColumns = (
  handleViewProject,
  viewLoading
) => [
    {
      Header: "ID",
      accessor: "id",
      title: "ID",
      isInfoIcon: false,
      isShortIcon: true,
      className: "text-center project_id ",
    },
    {
      Header: "Project Name",
      accessor: "project_name",
      isInfoIcon: false,
      isShortIcon: true,
      className: "project_name_box",
      Cell: cellProps => {
        return (
          <div className="d-flex gap-2 align-items-center">
            <span>{cellProps?.row?.original?.project_name}</span>
          </div>
        )
      },
    },
    {
      Header: "Customer",
      accessor: "customer_name",
      isInfoIcon: false,
      isShortIcon: true,
      className: "customer_name_box",
    },
    {
      Header: "Start Date",
      accessor: "startdate",
      isInfoIcon: false,
      isShortIcon: true,
      className: "start_date_box",
      Cell: cellProps => {
        return (
          <div className="">
            {moment(cellProps?.row?.original?.startdate).format("DD-MM-YYYY")}
          </div>
        )
      },
    },
    {
      Header: "End Date",
      accessor: "enddate",
      isInfoIcon: false,
      isShortIcon: true,
      className: " due_date_box text-center",
      Cell: cellProps => {
        return (
          <div className="">
            {moment(cellProps?.row?.original?.enddate).format("DD-MM-YYYY")}
          </div>
        )
      },
    },
    {
      Header: "Hours",
      accessor: "total_hrs",
      isInfoIcon: false,
      isShortIcon: true,
      className: "msupport_action text-center",
    },
    {
      accessor: "action",
      Header: "Action",
      className: "msupport_action text-center",
      Cell: cellProps => {
        return (
          <div className="d-flex justify-content-center">
            <button
              onClick={() => {
                handleViewProject(cellProps.row?.original?.id)
              }}
              disabled={viewLoading}
              className="btn btn-sm btn-outline-secondary me-1"
              title="Reply Ticket"
            >
              <i
                className={`fas fa-${viewLoading == cellProps.row?.original?.id
                    ? "circle-notch bx-spin"
                    : "arrow-right"
                  }`}
              ></i>
            </button>
          </div>
        )
      },
    },
  ]

export const timeSheetColumns = (dateRequired) => [
  {
    Header: "ID",
    accessor: "id",
    title: "ID",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-1 text-center",
    Cell: cellProps => {
      const data = cellProps?.row?.original
      const ids =
        data?.type == "activity"
          ? data?.id
          : data?.type == "project_task"
            ? data?.task_id
            : data?.type == "digital-project"
              ? data?.id
              : data?.id
      return <div>{ids}</div>
    },
  },
  {
    Header: "Activity Name",
    accessor: "project_name",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-5 ",
    Cell: cellProps => {
      const row = cellProps.row.original
      const rawAvatar = row?.avatar || row?.assignee_avatar || row?.staff_avatar
      const avatar =
        rawAvatar && rawAvatar !== "null"
          ? `${configure.imgUrl}${rawAvatar}`
          : null
      const name =
        row?.task_title || row?.subject || row?.name || row?.title || ""
      return (
        <div className="d-flex gap-2 align-items-center">
          <span>{name}</span>
        </div>
      )
    },
  },
  {
    Header: "Type",
    accessor: "type",
    title: "Type",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center",
    Cell: cellProps => {
      const type = cellProps?.row?.original?.type || "N/A"
      return <div className="text-capitalize">{type.replace("_", " ")}</div>
    },
  },
  ...(dateRequired ?
    [
      {
        Header: "Date",
        accessor: "date",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center",
        // Cell: cellProps => {
        //   const { date } = cellProps.row.original
        //   return <div>{date}</div>
        // }
      }
    ] : []),
  {
    Header: "Est.Time",
    accessor: "est_hrs",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center",
    Cell: cellProps => {
      const { est_hrs, estimation_time, estimate_time, type } =
        cellProps.row.original

      return (
        <div>
          {est_hrs ||
            estimation_time ||
            estimate_time ||
            `${type == "support_ticket" ? "-" : "-"}`}
        </div>
      )
    },
  },
  {
    Header: "Today's Time",
    accessor: "act_hrs",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center",
    Cell: cellProps => {
      const {
        act_hrs,
        dev_hrs,
        start_time,
        end_time,
        total_actual_time,
        type,
        todayTime
      } = cellProps.row.original
      let formattedDuration = "00:00"
      if (start_time && end_time) {
        const duration = moment.duration(
          moment(end_time).diff(moment(start_time))
        )
        const hours = Math.floor(duration.asHours())
        const minutes = duration.minutes()
        formattedDuration = `${String(hours).padStart(2, "0")}:${String(
          minutes
        ).padStart(2, "0")}`
      }
      return (
        <>
          {
            todayTime ? todayTime :
              <div>
                {
                  type === 'activity' ? `${total_actual_time}:00` :
                    (act_hrs ||
                      dev_hrs ||
                      `${type == "support_ticket"
                        ? convertMinutesToTimeString(total_actual_time || 0)
                        : ""
                      }` ||
                      `${type != "digital-project" || type != "support_ticket"
                        ? convertMinutesToTimeString(total_actual_time || 0) + ":00"
                        : ""
                      } `)}
              </div>
          }
        </>
      )
    },
  },
  {
    Header: "Act.Time",
    accessor: "time",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center",
    Cell: cellProps => {
      const { time } = cellProps.row.original
      return <div>{time}</div>
    },
  },
]

export const timeSheetApprovalColumns = (onPendingApprove) => [
  {
    Header: "ID",
    accessor: "id",
    title: "ID",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-1 text-center",
  },
  {
    Header: "Added By",
    accessor: "added_by_info",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-2",
    Cell: ({ value }) => {
      const rawAvatar = value?.avatar
      const avatar =
        rawAvatar && rawAvatar !== "null"
          ? `${configure.imgUrl}${rawAvatar}`
          : null

      const name = value?.alias_name || "-"

      return (
        <div className="d-flex gap-2 align-items-center">
          {avatar ? (
            <img
              src={avatar}
              alt="Avatar"
              className="img-fluid assignee-img"
              title={name}
            />
          ) : (
            <div className="defualt-img" title={name}>
              {getInitials(name)}
            </div>
          )}
          <span>{name}</span>
        </div>
      )
    },
  },

  {
    Header: "Title",
    accessor: "title",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-6 ",
    Cell: cellProps => {
      const row = cellProps.row.original
      const rawAvatar = row?.added_by_info?.avatar
      const avatar =
        rawAvatar && rawAvatar !== "null"
          ? `${configure.imgUrl}${rawAvatar}`
          : null
      const name = row?.title || ""
      return (
        <div className="d-flex gap-2 align-items-center">
          {/* {avatar && avatar != null ? (
            <img
              src={avatar}
              alt="Avatar"
              className="img-fluid assignee-img ms-2"
              title={row?.added_by_info?.alias_name || ""}
            />
          ) : (
            <div
              className="defualt-img "
              title={row?.added_by_info?.alias_name || ""}
            >
              {getInitials(row?.added_by_info?.alias_name || "")}
            </div>
          )} */}

          <span>{name}</span>
        </div>
      )
    },
  },

  {
    Header: "Start Time",
    accessor: "start_time",
    title: "Start Time",
    isInfoIcon: false,
    isShortIcon: true,
    className: "  text-center",
  },
  {
    Header: "End Time",
    accessor: "end_time",
    isInfoIcon: false,
    isShortIcon: true,
    className: " text-center",
  },
  {
    Header: "Staff",
    accessor: "staff_info",
    isInfoIcon: false,
    isShortIcon: true,
    className: " text-center",
    Cell: ({ value }) => value?.alias_name || "-",
  },
  {
    Header: "Total Time",
    accessor: "totaltime",
    isInfoIcon: false,
    isShortIcon: true,
    className: " text-center",
  },
  {
    Header: "Date",
    accessor: "date",
    isInfoIcon: false,
    isShortIcon: true,
    className: " text-center",
  },
  {
    accessor: "action",
    Header: "Action",
    className: "msupport_action text-center",
    Cell: cellProps => {
      return (
        <div className="d-flex justify-content-center">
          <a
            className="btn btn-sm btn-outline-primary me-1"
            title="Approve"
            onClick={() =>
              onPendingApprove(
                1,
                cellProps.row.original?.id
              )
            }
          >
            <i className="bi bi-check-lg icon-center"></i>
          </a>
          <a
            className="btn btn-sm btn-outline-danger me-1"
            title="Disapprove"
            onClick={() =>
              onPendingApprove(
                2,
                cellProps.row.original?.id
              )
            }
          >
            <i className="dripicons-cross icon-center"></i>
          </a>
        </div>
      )
    },
  },
]
